import React, { useEffect, useState } from 'react'
import { getStat } from 'ServerAPI'
import { CircularProgress } from '~/components/base/CircularProgress/CircularProgress'
import { formatBytes } from '~/Util'
import './Stats.scss'

export const Stats = () => {
  const [ stat, setStat ] = useState(null)
  const [ error, setError ] = useState(null)

  useEffect(() => {
    let isMounted = true
    getStat()
      .then(data => {
        if (isMounted) setStat(data)
      })
      .catch(err => {
        if (isMounted) setError(err)
      })
    return () => {
      isMounted = false
    }
  }, [])

  if (error) {
    return <div className="admin-panel__error">{String(error?.message || error)}</div>
  }

  if (!stat) {
    return (
      <div className="admin-panel__loading">
        <CircularProgress endless percents={80} transparent />
      </div>
    )
  }

  return (
    <div className="stats">
      {Object.entries(stat).map(([ key, value ]) => {
        const displayValue = key === 'totalUsersMediaFilesSize' ? `${formatBytes(value)}` : value
        return (
          <div key={key} className="stats__item">
            <span className="stats__label">
              {key}
              :
            </span>
            <span className="stats__value">{displayValue}</span>
          </div>
        )
      })}
    </div>
  )
}
